import { HFlow, ModalFooter, ModalFooterButton } from 'bold-ui'

interface NotificacaoAgravoModalFooterProps {
  isFirstStep: boolean
  isLastStep: boolean
  onClose: () => void
  onGoBack: () => void
  onSubmit: () => void
}

export function NotificacaoAgravoModalFooter(props: Readonly<NotificacaoAgravoModalFooterProps>) {
  const { isFirstStep, isLastStep, onClose, onGoBack, onSubmit } = props

  return (
    <ModalFooter>
      <HFlow alignItems='center' justifyContent={isFirstStep ? 'flex-end' : 'space-between'}>
        <ModalFooterButton kind={isFirstStep ? 'normal' : 'primary'} skin='outline' onClick={onClose}>
          Cancelar
        </ModalFooterButton>

        <HFlow alignItems='center' justifyContent='flex-end'>
          {!isFirstStep && <ModalFooterButton onClick={onGoBack}>Voltar</ModalFooterButton>}
          <ModalFooterButton kind='primary' onClick={onSubmit}>
            {isLastStep ? 'Concluir' : 'Continuar'}
          </ModalFooterButton>
        </HFlow>
      </HFlow>
    </ModalFooter>
  )
}
